import * as z from "zod";

import { sortUser } from "./user-model";

export const AssignedUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  username: z.string().nullable().optional(),
  fullname: z.string().nullable().optional(),
  profilePicture: z.string().nullable().optional(),
});

export type AssignedUser = z.infer<typeof AssignedUserSchema>;

export const AssigneeSchema = z.object({
  id: z.string(),
  userId: z.string().optional(), // Optional because not every query selects it
  workspaceId: z.string(),
  ownerId: z.string(),
  ownerType: z.string(),
  user: AssignedUserSchema.optional(), // Optional to support public dashboards where user data is not fetched
});

export type Assignee = z.infer<typeof AssigneeSchema>;

export const sortAssignee = (
  a?: Assignee | null | undefined,
  b?: Assignee | null | undefined,
  desc: boolean = false,
): 0 | 1 | -1 => {
  if (!a && !b) {
    return 0;
  }

  if (!a) {
    return desc ? 1 : -1;
  }

  if (!b) {
    return desc ? -1 : 1;
  }

  const userA = a?.user;
  const userB = b?.user;
  return sortUser(userA, userB, desc);
};

export const getAssigneeSectionKey = (assignee?: Assignee | null | undefined): string =>
  assignee?.userId ?? assignee?.id ?? "";

export const displayNameForAssignee = (assignee?: Assignee | null | undefined) => {
  if (!assignee || !assignee.user) {
    return "Unassigned";
  }

  if (assignee.user.username) {
    return assignee.user.username;
  }
  return assignee.user.email;
};
